var _path, _path2, _path3, _path4, _polygon, _path5, _circle, _path6, _path7, _circle2, _path8, _ellipse, _circle3, _path9, _polygon2, _polygon3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _path22, _rect2, _path23, _path24, _rect3, _path25, _path26, _path27, _path28, _circle4, _path29, _circle5, _path30, _circle6, _path31, _circle7, _path32, _circle8, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f9f705c9-8b4c-4439-a246-51ada304283b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 661.93033,
    height: 646.1539,
    viewBox: "0 0 661.93033 646.1539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M711.66086,406.33531l-6.9895,16.30885-42.869,56.848s-29.35593,31.68576-13.04708,33.54961,27.0261-29.35593,27.0261-29.35593l50.32447-49.85849,5.59161-22.83239Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#9f616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M733.09535,340.168l-6.75441,1.891s-30.32927,80.5696-27.53346,90.35488,15.37694,21.90046,20.96852,20.96854S733.09535,340.168,733.09535,340.168Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M827.473,754.21975s-2.96623,14.86337,5.94859,8.91483,13.56255-17.45249,13.56255-17.45249Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M721.91217,418.91644S627.32081,752.549,660.87043,762.33425s82.94217-.93191,82.47617-7.45545-8.85338-135.59648-8.85338-135.59648S783.41978,790.75825,843.99549,750.685s47.06271-47.52866,41.47108-50.32445-89.9316-135.59643-89.46564-160.2927-.93194-102.04684-11.18321-113.696Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "661.535 646.154 87.455 646.154 87.455 643.972 661.93 643.972 661.535 646.154",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M781.99257,300.29641a19.56832,19.56832,0,0,1-2.431-26.38343c-.394.36941-.77917.753-1.14786,1.16083a19.57064,19.57064,0,0,0,29.03339,26.25074c.36871-.40778.71167-.82951,1.0397-1.25863A19.56831,19.56831,0,0,1,781.99257,300.29641Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 511.12321,
    cy: 137.75822,
    r: 40.30616,
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M671.58767,760.93638s-10.71724,10.71725,0,10.71725,20.96852-6.9895,20.96852-6.9895Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M754.52985,289.8435s6.9895,28.89,1.86388,34.48158-16.30886,9.78531-16.30886,9.78531l1.86388,52.18834s21.4345-7.45547,22.36643-8.38741,20.03658-31.21979,20.03658-31.21979l18.63869-17.70675s-28.424-13.51305-20.03661-36.81145S754.52985,289.8435,754.52985,289.8435Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#9f616a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 771.77065,
    cy: 276.33045,
    r: 24.2303,
    transform: "translate(106.34957 866.94931) rotate(-80.78253)",
    fill: "#9f616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M784.81773,426.37189s10.71724-35.41351,15.84288-40.07318,17.70677-48.4606,17.70677-48.4606-7.92145-10.71725-14.445-10.71725-12.5811,2.32984-20.03657,9.31938c-3.51093,3.29151-9.91471,6.913-15.70816,9.82385a17.37836,17.37836,0,0,1-23.52431-7.8517c-1.15838-2.46136-1.53968-4.81975-.37476-6.63185,0,0-17.24079,4.65968-18.17273,11.18322s0,20.03658-1.39789,22.83239-5.5916,6.9895-3.72773,24.69627-1.94539,40.09737-1.94539,40.09737C736.44115,447.199,760.55547,436.94648,784.81773,426.37189Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#6c63ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.50281,
    cy: 127.73993,
    rx: 20.50256,
    ry: 13.97902,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.45037,
    cy: 107.23736,
    r: 19.57062,
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M820.46421,248.13943a19.5683,19.5683,0,0,1-19.4977-17.93974c-.04447.53829-.07292,1.08113-.07292,1.63091a19.57063,19.57063,0,0,0,39.14125.01664v-.01664c0-.54976-.02845-1.09259-.07292-1.63091A19.5683,19.5683,0,0,1,820.46421,248.13943Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.528 420.53 499.018 420.53 486.008 534.01 528.918 532.57 505.528 420.53",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "505.528 420.53 499.018 420.53 486.008 534.01 528.918 532.57 505.528 420.53",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.358 419.08 495.408 533.29 592.798 540.52 600.748 429.2 503.358 419.08",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 536.14794,
    cy: 429.20005,
    r: 1.45001,
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.50796,
    cy: 432.81005,
    r: 1.45001,
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M835.90278,559.74309h-.72c0-.31.51-30.8-17-33.61-3.45-.55-6.27.23-8.38,2.32-7.23,7.17-4.24,27.42-4.21,27.62l-.71.11c-.13-.85-3.07-20.82,4.42-28.24,2.28-2.27,5.32-3.12,9-2.53C836.42277,528.31309,835.91279,559.4331,835.90278,559.74309Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M819.76526,402.1416l-2.32984,26.09417,4.65967,78.28248s10.71725,39.60716-5.59163,38.67529-10.25129-41.47108-10.25129-41.47108l-7.45548-90.86361Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#9f616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M806.25222,331.31458l12.11512,6.52355s16.30887,110.848,6.98949,121.56525-28.424,14.91095-29.35593,10.71724-4.19371-89.41351-4.19371-89.41351Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M334.99647,126.92305h-13.589a1.80162,1.80162,0,0,0-1.80162,1.80162v5.9646a1.80162,1.80162,0,0,0,1.80162,1.80162h2.25189v8.937h9.08517v-8.937h2.25189a1.80163,1.80163,0,0,0,1.80162-1.80162v-5.9646A1.80163,1.80163,0,0,0,334.99647,126.92305Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M348.60726,181.511a69.86284,69.86284,0,0,1-12.154-41.42092,1.47343,1.47343,0,0,0-1.15009-1.47037v-2.57728H320.95138v2.54146h-.19775a1.47261,1.47261,0,0,0-1.4707,1.47453q.00006.05364.004.10718,1.696,23.64147-11.45382,42.40243a4.05847,4.05847,0,0,0-.73449,2.45945l1.56929,48.54266a4.2022,4.2022,0,0,0,4.16627,4.05578H345.2957a4.20367,4.20367,0,0,0,4.16877-4.12732l.60474-47.131A8.50594,8.50594,0,0,0,348.60726,181.511Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.46854,197.63534H315.21335a2.90091,2.90091,0,0,0-2.86717,3.342l4.26977,27.75348h24.51757l5.18624-27.66a2.90095,2.90095,0,0,0-2.85122-3.43551Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M486.26775,272.33867H472.6788a1.80162,1.80162,0,0,0-1.80162,1.80162v5.9646a1.80162,1.80162,0,0,0,1.80162,1.80162h2.25189v8.937h9.08518v-8.937h2.25188a1.80162,1.80162,0,0,0,1.80162-1.80162v-5.9646A1.80162,1.80162,0,0,0,486.26775,272.33867Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M499.87854,326.92662a69.86284,69.86284,0,0,1-12.154-41.42092,1.47343,1.47343,0,0,0-1.15009-1.47037v-2.57728H472.22266v2.54146h-.19775a1.47261,1.47261,0,0,0-1.4707,1.47453q.00006.05364.004.10718,1.696,23.64147-11.45381,42.40243a4.05838,4.05838,0,0,0-.7345,2.45945l1.56929,48.54265a4.2022,4.2022,0,0,0,4.16627,4.05579H496.567a4.20368,4.20368,0,0,0,4.16877-4.12732l.60474-47.13095A8.50594,8.50594,0,0,0,499.87854,326.92662Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M494.73982,343.051H466.48463a2.90091,2.90091,0,0,0-2.86716,3.342l4.26976,27.75348H492.4048l5.18624-27.66a2.90095,2.90095,0,0,0-2.85122-3.43551Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M315.89218,477.91365h-6.44586a.85459.85459,0,0,0-.85459.85459v2.82929a.85459.85459,0,0,0,.85459.85459h1.06818v4.23922H314.824v-4.23922h1.06817a.85459.85459,0,0,0,.85459-.85459v-2.82929A.85459.85459,0,0,0,315.89218,477.91365Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3484,503.80721a33.13912,33.13912,0,0,1-5.76522-19.64783.69891.69891,0,0,0-.54554-.69746v-1.22253h-6.80769v1.20553h-.0938a.69853.69853,0,0,0-.69762.69944q0,.02544.00192.05084a30.24345,30.24345,0,0,1-5.43307,20.11341,1.925,1.925,0,0,0-.3484,1.16663l.74438,23.026a1.99329,1.99329,0,0,0,1.97625,1.92384h15.398a1.994,1.994,0,0,0,1.97744-1.95777l.28685-22.35637A4.03473,4.03473,0,0,0,322.3484,503.80721Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.40532,
    y: 385.34835,
    width: 14.69218,
    height: 7.34609,
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M345.89782,477.91365H339.452a.85459.85459,0,0,0-.85459.85459v2.82929a.85459.85459,0,0,0,.85459.85459h1.06817v4.23922h4.30952v-4.23922h1.06817a.85459.85459,0,0,0,.85459-.85459v-2.82929A.85459.85459,0,0,0,345.89782,477.91365Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M352.354,503.80721a33.13912,33.13912,0,0,1-5.76522-19.64783.69891.69891,0,0,0-.54554-.69746v-1.22253h-6.80769v1.20553h-.0938a.69853.69853,0,0,0-.69762.69944q0,.02544.00192.05084a30.24345,30.24345,0,0,1-5.43307,20.11341,1.925,1.925,0,0,0-.3484,1.16663l.74438,23.026a1.99329,1.99329,0,0,0,1.97625,1.92384h15.398a1.994,1.994,0,0,0,1.97743-1.95777l.28686-22.35637A4.0348,4.0348,0,0,0,352.354,503.80721Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.41096,
    y: 385.34835,
    width: 14.69218,
    height: 7.34609,
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M375.90346,477.91365H369.4576a.85459.85459,0,0,0-.85459.85459v2.82929a.85459.85459,0,0,0,.85459.85459h1.06817v4.23922h4.30952v-4.23922h1.06817a.85459.85459,0,0,0,.85459-.85459v-2.82929A.85459.85459,0,0,0,375.90346,477.91365Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M382.35968,503.80721a33.13912,33.13912,0,0,1-5.76522-19.64783.69891.69891,0,0,0-.54554-.69746v-1.22253h-6.80769v1.20553h-.0938a.69853.69853,0,0,0-.69762.69944q0,.02544.00192.05084a30.24345,30.24345,0,0,1-5.43307,20.11341,1.92512,1.92512,0,0,0-.34841,1.16663l.74439,23.026a1.99329,1.99329,0,0,0,1.97625,1.92384h15.398a1.994,1.994,0,0,0,1.97744-1.95777l.28686-22.35637A4.0348,4.0348,0,0,0,382.35968,503.80721Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4166,
    y: 385.34835,
    width: 14.69218,
    height: 7.34609,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M462.66064,421.65806H449.0717a1.80163,1.80163,0,0,0-1.80163,1.80162v5.9646a1.80163,1.80163,0,0,0,1.80163,1.80162h2.25188v8.937h9.08518v-8.937h2.25188a1.80162,1.80162,0,0,0,1.80162-1.80162v-5.9646A1.80162,1.80162,0,0,0,462.66064,421.65806Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M476.27144,476.246a69.86282,69.86282,0,0,1-12.15406-41.42092,1.47342,1.47342,0,0,0-1.15009-1.47037v-2.57729H448.61555v2.54146h-.19775a1.47261,1.47261,0,0,0-1.4707,1.47453q.00006.05365.004.10718,1.696,23.64149-11.45381,42.40243a4.05834,4.05834,0,0,0-.73449,2.45945l1.56928,48.54266a4.2022,4.2022,0,0,0,4.16627,4.05578h32.46148a4.20366,4.20366,0,0,0,4.16877-4.12731l.60474-47.131A8.50588,8.50588,0,0,0,476.27144,476.246Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M471.13271,492.37035H442.87752a2.90092,2.90092,0,0,0-2.86716,3.342l4.26976,27.75348H468.7977l5.18623-27.66a2.901,2.901,0,0,0-2.85122-3.43552Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M470.07925,243.87511H389.07592c5.66326-30.61868,4.36035-67.59179,0-107.35381h81.00333C465.83487,176.28344,464.56657,213.25649,470.07925,243.87511Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.03072,
    cy: 60.34733,
    r: 19.51888,
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M395.90752,386.3629H314.90419c5.66326-30.61869,4.36036-67.59179,0-107.35381h81.00333C391.66315,318.77123,390.39485,355.74427,395.90752,386.3629Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.85899,
    cy: 202.83511,
    r: 19.51888,
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M515.9486,250.70672H434.94527c5.66327-30.61869,4.36036-67.59179,0-107.35381H515.9486C511.70423,183.11505,510.43593,220.08809,515.9486,250.70672Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.90008,
    cy: 67.17893,
    r: 19.51888,
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M515.9486,245.827H434.94527c5.66327-30.61869,4.36036-67.59179,0-107.35381H515.9486C511.70423,178.23533,510.43593,215.20837,515.9486,245.827Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.90008,
    cy: 62.29921,
    r: 19.51888,
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M515.9486,250.70672H434.94527c5.66327-30.61869,4.36036-67.59179,0-107.35381H515.9486C511.70423,183.11505,510.43593,220.08809,515.9486,250.70672Z",
    transform: "translate(-269.03484 -126.92305)",
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.90008,
    cy: 67.17893,
    r: 19.51888,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 111.0964,
    width: 265.4567,
    height: 29.27831,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 256.51202,
    width: 265.4567,
    height: 29.27831,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 401.92764,
    width: 265.4567,
    height: 29.27831,
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/Store.e966b6c723b91e9d93642f3742a6b7a0.svg";
export { ForwardRef as ReactComponent };